import { useEmployeeService } from 'domain/shared/employee';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { isEmployeeContractByType, isPolishOffice } from 'domain/shared/employee';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { AfterSubmitProps, FormFieldsData, ModalForm } from 'framework/form';
import { useShowContext } from 'framework/show';
import EmployeeDocumentsForm from '../../../createupdate/EmployeeDocumentsForm';
import { EmployeeDocumentType, EmployeeDocumentFormShowType } from '../../../types';

const EditEmployeeDocumentAction = ({
  modalOpen,
  closeModal,
  afterSubmit,
}: {
  modalOpen: boolean;
  closeModal: () => void;
  afterSubmit: AfterSubmitProps<(response: FormFieldsData) => void>;
}) => {
  const id = useEmployeeId();
  const { data } = useShowContext<EmployeeDocumentType>();
  const { editDocument, getValidationSchema } = useDocumentStorageContext();
  const { getById } = useEmployeeService();
  const documentData = data.getData();

  const loadFormData = async (): Promise<Nullable<EmployeeDocumentFormShowType>> => {
    if (!id) return null;
    const employee = await getById(id);

    const isPolishContractEmployee =
      employee && isPolishOffice(String(employee.officeId)) && isEmployeeContractByType(String(employee.contractType));

    return {
      ...documentData.metadata,
      employeeAlias: documentData.metadata.employeeAlias || id,
      paths: [documentData.path],

      // Only for validation
      isPolishContractEmployee,
    };
  };

  if (!id) {
    return null;
  }

  return (
    <ModalForm
      getValidationSchemaFunc={getValidationSchema}
      modalOpen={modalOpen}
      closeModal={closeModal}
      handleDirty
      submitFormFunc={editDocument}
      afterSubmit={{
        ...afterSubmit,
      }}
      getDataFunc={loadFormData}
    >
      <EmployeeDocumentsForm isEditForm />
    </ModalForm>
  );
};

export default EditEmployeeDocumentAction;
